import { Component, OnInit, OnDestroy, Input, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute } from "@angular/router";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-waste-index',
    templateUrl: './waste-index.component.html',
    styleUrls: ['./waste-index.component.css'],
    standalone: false
})
export class WasteIndexComponent implements OnInit, OnDestroy {
  authService = inject(AuthService);
  private route = inject(ActivatedRoute);

  @Input() deId = false;
  dissableDeIdSwitch = false;
  private readonly destroy$ = new Subject<void>();


  ngOnInit(): void {
    const deIdState = this.authService.getDeIdState();
    this.deId = deIdState.value;
    this.dissableDeIdSwitch = deIdState.disabled;
    
    this.route.data.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.deId = this.authService.isDemoUser() ? true : x.deId;
    });

    const body = document.getElementsByTagName('body')[0];
    body.className = "";
    body.classList.add('subpage');
    body.classList.add('waste');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updateDeIdMode(value: boolean) {
    if (!this.authService.isDemoUser()) {
      this.deId = value;
      this.authService.setDeIdentified(value);
    }
  }
}
